// extracted by mini-css-extract-plugin
module.exports = {"root":"main-page_root__1NqwT","list":"main-page_list__2dLEI","listDisabled":"main-page_listDisabled__1BfqC","viewer":"main-page_viewer__16p7-"};